function createTooltipBadge(color) {
    return `<div style="width: 8px; min-width: 8px; max-width: 8px; height: 8px; min-height: 8px; max-height: 8px; background: ${color}; border-radius: 100px; flex: none; order: 0; flex-grow: 0;"></div>`;
}
function createTooltipLabel(name) {
    return `<div style="font-family: 'Source Sans 3', var(--font-family-base); font-style: normal; font-weight: 400; font-size: 12px; line-height: 17px; display: flex; align-items: center; color: #666666; flex: none; order: 1; flex-grow: 1;">${name}</div>`;
}
function createTooltipValueElement(value) {
    return `<div style="font-family: 'Source Sans 3', var(--font-family-base); font-style: normal; font-weight: 400; font-size: 12px; line-height: 17px; display: flex; align-items: center; text-align: right; color: #666666; flex: none; order: 2; flex-grow: 0;">${value}</div>`;
}
function createTooltipItem(item) {
    const badge = createTooltipBadge(item.color);
    const label = createTooltipLabel(item.name);
    const value = createTooltipValueElement(item.value);
    return `<div style="display: flex; flex-direction: row; align-items: center; gap: 8px; width: 148px; height: 17px;">${badge}${label}${value}</div>`;
}
function createTooltipTitle(title) {
    return `<div style="font-family: 'Source Sans 3', var(--font-family-base); font-style: normal; font-weight: 400; font-size: 12px; line-height: 17px; color: #666666; margin-bottom: 4px;">${title}</div>`;
}
function createTooltipContainer(items, title) {
    const titleHtml = title ? createTooltipTitle(title) : '';
    return `<div style="display: flex; flex-direction: column; gap: 8px; width: 180px;">${titleHtml}${items}</div>`;
}
export function createEChartsTooltipFormatter(tooltipData) {
    const tooltipItems = tooltipData.items.map(item => createTooltipItem(item)).join('');
    return createTooltipContainer(tooltipItems, tooltipData.title);
}
